import axios from "axios"

import { BOOKING_LINK_HEADER } from "./bookingApi"

/**
 * API client for the /book page. The booking link is its only credential and
 * only works on the public booking endpoints; it chooses the user, so nothing
 * in the page or its requests can name a different one.
 */
export function createBookingLinkClient(token) {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { [BOOKING_LINK_HEADER]: token },
  })
}
